import Layout from "@/layout/index.vue";

export default [
  // 监控大盘
  {
    path: "/jkdp",
    name: "jkdp",
    component: Layout,
    redirect: "/jkdp/short-insure-term",
    meta: {
      title: "监控大盘",
    },
    children: [
      {
        path: "/jkdp/short-insure-term",
        name: "jkdpShortInsureTerm",
        component: () => import("@/views/jkdp/pages/short-insure-term/index.vue"),
        meta: {
          title: "短险监控-所属期",
          newPage: true,
        },
      },
      {
        path: "/jkdp/short-insure-today",
        name: "jkdpShortInsureToday",
        component: () => import("@/views/jkdp/pages/short-insure-today/index.vue"),
        meta: {
          title: "短险监控-当日",
          newPage: true,
        },
      },
      {
        path: "/jkdp/seat-evaluate",
        name: "jkdpSeatEvaluate",
        component: () => import("@/views/jkdp/pages/seat-evaluate/index.vue"),
        meta: {
          title: "客服评价报表",
          newPage: true,
        },
      },
      {
        path: "/jkdp/complaint-stats",
        name: "jkdpComplaintStats",
        component: () => import("@/views/jkdp/pages/complaint-stats/index.vue"),
        meta: {
          title: "投诉报表",
          newPage: true,
        },
      },{
        path: "/jkdp/detainment-pro",
        name: "jkdpDetainmentPro",
        component: () => import("@/views/jkdp/pages/detainment-pro/index.vue"),
        meta: {
          title: "均分挽留报表",
          newPage: true,
        },
      },
      {
        path: "/jkdp/complaint-dispose-stats",
        name: "jkdpComplaintDisposeStats",
        component: () => import("@/views/jkdp/pages/complaint-dispose-stats/index.vue"),
        meta: {
          title: "投诉处理能力",
          newPage: true,
        },
      },
      {
        path: "/jkdp/monitor-custom",
        name: "monitorCustom",
        component: () => import("@/views/jkdp/pages/monitorCustom/index"),
        meta: {
          title: "自定义报表",
          newPage: true,
        },
      },
      {
        path: "/jkdp/a-merge-deduct",
        name: "jkdpAMergeDeduct",
        component: () => import("@/views/jkdp/pages/a-merge-deduct/index.vue"),
        meta: {
          title: "a段合并扣费",
          newPage: true,
        },
      },
      {
        path: "/jkdp/a-relegate-deduct",
        name: "jkdpARelegateDeduct",
        component: () => import("@/views/jkdp/pages/a-relegate-deduct/index.vue"),
        meta: {
          title: "降级扣费",
          newPage: true,
        },
      },
    ],
  },
  // 客服管理
  {
    path: "/kf",
    name: "kf",
    component: Layout,
    // redirect: "/kf/callin-record",
    meta: {
      title: "客服管理",
    },
    children: [
      {
        path: "/kf/callin-record-visitor",
        name: "kfCallinRecordVisitor",
        component: () => import("@/views/kefu/pages/callin-record/callin-record-visitor.vue"),
        meta: {
          title: "通话数据统计",
          newPage: true,
          noCache: true,                                    
        },
      },
      {
        path: "/kf/immediate-status",
        name: "kfImmediateStatus",
        component: () => import("@/views/kefu/pages/immediate-status/index.vue"),
        meta: {
          title: "客服实时状态",
          newPage: true,
        },
      },
      {
        path: "/kf/call-tape-record",
        name: "kfcallTapeRecord",
        component: () => import("@/views/kefu/pages/call-tape-record/index.vue"),
        meta: {
          title: "通话录音查询",
          newPage: true,
        },
      },
    ],
  },
  // 业务监控
  {
    path: "/monitor",
    name: "monitor",
    component: Layout,
    redirect: "/monitor/daily-base",
    meta: {
      title: "业务报表",
    },
    children: [
      {
        path: "/monitor/daily-base",
        name: "monitorDailyBase",
        component: () => import("@/views/monitor/pages/daily-base/index.vue"),
        meta: {
          title: "转化数据报表",
          newPage: true,
        },
      },
      {
        path: "/monitor/daily-rb",
        name: "monitorDailyRb",
        component: () => import("@/views/monitor/pages/daily-rb/index.vue"),
        meta: {
          title: "点拨报表",
          newPage: true,
        },
      },
      {
        path: "/monitor/daily-hnzj",
        name: "monitorDailyHnzj",
        component: () => import("@/views/monitor/pages/daily-hnzj/index.vue"),
        meta: {
          title: "人保魔方链路转化报表",
          newPage: true,
        },
      },
      {
        path: "/monitor/daily-jf",
        name: "monitorDailyJf",
        component: () => import("@/views/monitor/pages/daily-jf/index.vue"),
        meta: {
          title: "均分坐席人效报表",
          newPage: true,
        },
      },
        {
            path: "/monitor/daily-zx",
            name: "monitorDailyZx",
            component: () => import("@/views/monitor/pages/daily-zx/index.vue"),
            meta: {
                title: "0.2意外赠险转均分报表",
                newPage: true,
            },
        },
        {
            path: "/monitor/daily-qywx",
            name: "monitorDailyQywx",
            component: () => import("@/views/monitor/pages/daily-qywx/index.vue"),
            meta: {
                title: "企微运营报表",
                newPage: true,
            },
        },
        {
            path: "/monitor/jf-sale-stats",
            name: "monitorJfsaleStats",
            component: () => import("@/views/monitor/pages/jf-sale-stats/index.vue"),
            meta: {
                title: "均分销售转化效率追踪",
                newPage: true,
            },
        },
        {
            path: "/monitor/urge-pay",
            name: "monitorUrgePay",
            component: () => import("@/views/monitor/pages/urge-pay/index.vue"),
            meta: {
                title: "催缴报表",
                newPage: true,
            },
        },
        {
            path: "/monitor/ai-stats",
            name: "monitorAiStats",
            component: () => import("@/views/monitor/pages/ai-stats/index.vue"),
            meta: {
                title: "AI报表",
                newPage: true,
            },
        },
        {
            path: "/monitor/seat-jf",
            name: "monitorSeatJf",
            component: () => import("@/views/monitor/pages/seat-jf/index.vue"),
            meta: {
                title: "均分报表",
                newPage: true,
            },
        },
    ],
  },
]
